import { ReactElement } from 'react'

import { BankAccount } from '@features/bankAccounts/types/bankAccount'
import { Account } from '@modules-deprecated/app/accounts/types'

import { isKontistAccount } from '../../../../../../../../utils/accountTypeCheckers'
import { CardActionType } from '../../enums/cardActionType'
import { SyncStatus } from '../../enums/syncStatus'
import { BaseAccountCard } from '../BaseAccountCard'

interface AccountCardProps {
  account: Account
  bankAccount?: BankAccount
}

export const AccountCard = ({ account, bankAccount }: AccountCardProps): ReactElement => {
  const { name, id, description, accountNo } = account

  const isKontist = isKontistAccount(account)
  const syncStatus = isKontist ? SyncStatus.Realtime : SyncStatus.OfflineData
  const actionItems = isKontist
    ? [CardActionType.DownloadTransactions, CardActionType.HideAccount]
    : [
        CardActionType.ConnectToBank,
        CardActionType.UploadToAccount,
        CardActionType.DownloadTransactions,
        CardActionType.EditAccount,
        CardActionType.HideAccount,
      ]

  return (
    <BaseAccountCard
      account={{
        externalAccountId: id,
        accountName: description,
        accountNo,
        bankAccountId: bankAccount?.id,
      }}
      bankName={name}
      syncStatus={syncStatus}
      actionItems={actionItems}
    />
  )
}
